// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1BR_O","title":"Header_title__1Zu_q","side":"Header_side__2X9C8"};